"use client";
import { createContext, useContext } from "react";

export type Country = {
  iso: string;
  name: string;
  dialCode: string;
  id: number;
};

export type BillingDetail = {
  billingCode?: string;
  billingCountryId?: Country["id"];
  billingZipCode?: string;
  billingTaxNumber?: string;
};

export type SharedContextVal = {
  billingCountry: Country;
  setBillingCountry: (country: Country) => unknown;
  billingZipCode: BillingDetail["billingZipCode"];
  setBillingZipCode: (zip: BillingDetail["billingZipCode"]) => unknown;
  billingNote: BillingDetail["billingNote"];
  setBillingNote: (note: BillingDetail["billingNote"]) => unknown;
  billingTaxNumber: BillingDetail["billingTaxNumber"];
  setBillingTaxNumber: (tax: BillingDetail["billingTaxNumber"]) => unknown;
};

export const CheckoutContext = createContext<SharedContextVal>({
  billingCountry: {} as Country,
  setBillingCountry: () => null,
  billingZipCode: "",
  setBillingZipCode: () => null,
  billingNote: "",
  setBillingNote: () => null,
  billingTaxNumber: "",
  setBillingTaxNumber: () => null,
});

export const useCheckoutContext = () => useContext(CheckoutContext);
